import { Volume2 } from "lucide-react";

import { IconButton } from "./IconButton";

export interface CurriculumVoiceButtonProps {
  readonly disabled?: boolean;
  readonly isPlaying?: boolean;
  readonly label: string;
  readonly onPlay: () => void;
}

export function CurriculumVoiceButton({
  disabled = false,
  isPlaying = false,
  label,
  onPlay
}: CurriculumVoiceButtonProps) {
  const accessibleLabel =
    (isPlaying ? "正在朗读：" : "朗读：") + label;

  return (
    <IconButton
      aria-busy={isPlaying || undefined}
      className="ui-curriculum-voice"
      data-playing={isPlaying}
      disabled={disabled}
      icon={Volume2}
      label={accessibleLabel}
      onClick={(event) => {
        event.stopPropagation();
        onPlay();
      }}
      onPointerDown={(event) => {
        event.stopPropagation();
      }}
      tooltip={accessibleLabel}
      variant={isPlaying ? "accent" : "neutral"}
    />
  );
}
